<!--
 * @Author: 张天昊
 * @Date: 2024-09-10 11:52:55
 * @LastEditTime: 2024-09-10 11:54:59
 * @LastEditors: 张天昊
 * @Description: 
 * @FilePath: /Mobile/src/components/FilePreviewer/UploadTriggerCell.vue
-->
<script>
import { defineComponent } from 'vue';
import UploadTrigger from './UploadTrigger.vue';
export default defineComponent({
  components: {
    UploadTrigger
  },
  props: {
    color: String
  }
});
</script>
<template>
  <div
    class="van-hairline--top mt-16 flex items-center pt-16"
    @click="$emit('click')"
  >
    <div class="h-32 w-32">
      <UploadTrigger :color="color" :icon-size="9" />
    </div>
    <span class="ml-8 text-14 leading-14" :style="{ color }">
      <slot>继续添加</slot>
    </span>
  </div>
</template>
